export const environment = {
  name: 'preprod',
  production: false,
  traceLabUrl: "https://api.preprod.cotral.com/OData.TraceLab.API/api",
  redirectUri: "https://trainingcodeadmin.preprod.cotral.com",
  keycloak: {
    initConfig: {
      url: 'https://preprod.kc.cotral.com/auth',
      realm: 'Cotral',
      clientId: 'TrainingCodeAdmin',
    },
    scope: 'openid profile email roles web-origins',
    idpHintCotral: 'azure-ad',
  },
  keycloakApiConfig: {
    url: 'https://preprod.kc.cotral.com/auth',
    realm: 'Cotral',
    clientId: 'ESB',
    clientSecret: '48aae4fc-5af2-442a-8a86-153192433735',
    grantType: 'client_credentials',
    scope: 'openid profile email roles'
  },
  mailApi: {
    issuer: 'https://auth.cotral.com/auth',
    url: "https://api.cotral.com/Mail.API/api/v1/mail",
    clientId: 'mail-api',
    clientSecret: '5b308893-4c21-4d21-afef-6b0c9d65c791',
    grantType: 'client_credentials',
    scope: 'openid profile email roles'
  },
  orderErrorsListUri: 'https://artagroup.sharepoint.com/sites/ServiceclientGestiondeprod/Lists/Cartes%20Formation%20et%20Cotral%20Academy/AllItems.aspx'
}
